module.exports = __webpack_public_path__ + "static/media/RollingStone.0423592f.png";